import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDownloadOutlinedGreen = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M11.25 2.625H6.75V7.125H3.75L9 12.375L14.25 7.125H11.25V2.625ZM9.75006 4.125V8.625H10.6276L9.00006 10.2525L7.37256 8.625H8.25006V4.125H9.75006ZM3.75 15.375V13.875H14.25V15.375H3.75Z",
		fill: "#14803C"
	})
});
export default SvgDownloadOutlinedGreen;
